module.exports = __webpack_public_path__ + "img/zhedie.263b84ea.jpg";